export enum RevenueType {
  Revenue = 'revenue',
  Pipeline = 'pipeline'
}

